import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";
import Validation from "~/lib/validation";
import {process as processRules} from "~/modules/auth/validations";
import {ButtonInfo} from "~/components/buttons/button-info";
import {resetPassword} from "~/modules/auth/service";

export type PasswordStepMessage = {
  title: string;
  description: string;
  error: string;
  success: string;
};


@Component
class ChangePasswordStep extends Vue {

  @Prop({type: Object, required: true}) messages: PasswordStepMessage;
  @Prop({type: String, required: true}) type: "lost-password" | "account-activation";
  @Prop({type: String, required: true}) code: string;

  protected isLoading: boolean = false;
  protected isValid: boolean = false;
  protected nextPassword: string = null;
  protected nextPasswordConfirm: string = null;
  protected validation = null
  protected validationErrors = null;
  protected sent: boolean = false;
  protected error: boolean = false

  @Watch("nextPassword")
  @Watch("nextPasswordConfirm")
  async onInputChange() {
    try {
      await this.validation.validate({
        nextPassword: this.nextPassword,
        nextPasswordConfirm: this.nextPasswordConfirm
      });
      this.isValid = true;
    } catch (err) {
      this.isValid = false;
    }
  }

  created() {
    this.validation = new Validation({
      ...processRules,
      nextPasswordConfirm: [
        Validation.required,
        Validation.custom({
          type: "nextPasswordConfirm",
          fn: x => x === this.nextPassword
        })
      ]
    });
  }

  async validate() {
    try {
      this.validationErrors = null;
      await this.validation.validate({
        nextPassword: this.nextPassword,
        nextPasswordConfirm: this.nextPasswordConfirm
      })
      return true;
    } catch (err) {
      this.validationErrors = err;
      return false;
    }
  }

  showResultMessage() {
    return this.sent || this.error;
  }

  renderValidationError(key, source, messages) {
    if (!source) return null;
    if (source[key]) {
      for (let i = 0; i < source[key].types.length; ++i) {
        let errorType = source[key].types[i];
        if (messages[errorType]) return (
          <div class="message is-danger">
            <p class="message-body">
              {messages[errorType]}
            </p>
          </div>
        );
      }
    }
  }

  protected async sendRequest() {
    throw new Error(`sendRequest must be implemented.`);
  }

  async submit(e) {
    e.preventDefault();

    if (await this.validate()) {
      this.isLoading = true;
      try {
        await this.sendRequest()
        this.sent = true;
      } catch (err) {
        this.error = err;
      }
      this.isLoading = false;
    } else {
      console.log(this.validationErrors);
    }
  }

  render() {

    if (this.showResultMessage()) {
      return (
        <p class="instructions">
          {this.error ? this.messages.error : this.messages.success}
          {!this.error && <button class={"button btn--action-primary btn--large login"} onClick={() => this.$router.push({ name: 'login' })}>Connexion</button>}
        </p>
      );
    }

    return (
      <div>

        <div class="m-b-30 instructions">
          <h2 class="subtitle">{this.messages.title}</h2>
          <p>{this.messages.description}</p>
        </div>

        <div class="field">
          <label for="nextPassword" class="label">Mot de passe</label>
          <div class="control">
            <input type="password" class="input" id="nextPassword" name="nextPassword" v-model={this.nextPassword}/>
            <ButtonInfo class="info has-tooltip-left" dataTooltip="Nouvelle carte"
                        data-tooltip={this.$t("user.wrongPasswordRegex")}/>
          </div>
        </div>

        {this.renderValidationError("nextPassword", this.validationErrors, {
          required: "Nouveau mot de passe requis",
          pattern: this.$t("user.wrongPasswordRegex")
        })}

        <div class="field">
          <label for="nextPasswordConfirm" class="label">Confirmation de mot de passe</label>
          <div class="control">
            <input type="password" class="input" id="nextPasswordConfirm" name="nextPasswordConfirm"
                   v-model={this.nextPasswordConfirm}/>
          </div>
        </div>

        {this.renderValidationError("nextPasswordConfirm", this.validationErrors, {
          required: "Confirmation du mot de passe requise",
          nextPasswordConfirm: "Confirmation du mot de passe requise"
        })}

        <div class="field has-text-centered m-t-20">
          <button onClick={this.submit}
                  class={className("button btn--action-primary btn--large ", {isLoading: this.isLoading})}
                  disabled={!this.isValid}>
            Valider
          </button>
        </div>


      </div>
    );
  }

}

export {ChangePasswordStep}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-248d769e/change-password-step.tsx" });